export const formatDate = (input: Date | string): string => {
	const date = typeof input === "string" ? new Date(input) : input;

	if (isNaN(date.getTime())) {
		throw new Error("Invalid date input");
	}

	const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
	return date.toLocaleDateString('ar-EG', options);
}